export default __webpack_public_path__ + "static/media/logo.6fb95f09.png";